import styled, {css} from 'styled-components';
import {device} from 'styled/device';
import {ErrorMessage as BaseErrorMessage} from 'styled/common';
import Input from 'components/acommon/FieldInput';
import Select from 'components/acommon/FieldSelect';
import Tooltip from '../../Tooltip';
import {Label as BaseLabel} from 'components/acommon/FieldInput/styled';

export const Label = styled(BaseLabel)`
  margin-right: 6px;
`;

type WrapperProps = {
  disabled?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  /* width: 288px; */
  position: relative;
  min-height: 56px;

  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;

      & ${Label} {
        opacity: 0.3;
      }
    `};

  @media (max-width: ${device.mobileS}) {
    width: 100%;
  }
`;

export const FieldsWrapper = styled.div`
  display: flex;
  gap: 10px;
  position: relative;
  align-items: flex-end;
`;

export const DateInput = styled(Input)`
  font-family: Poppins, sans-serif;
  font-size: 16px;
  min-width: 60px;
  max-width: 79px;
  min-height: 36px;

  & input {
    padding-right: 5px;
  }

  & ${BaseLabel} {
    display: none;
  }

  @media (max-width: ${device.mobileS}) {
    width: 100%;
  }
`;

export const DateSelectWrapper = styled.div`
  display: inline-block;
  position: relative;
`;

export const DateSelect = styled(Select)`
  width: 150px;
  min-height: 36px;
  min-width: 0;

  & .select {
    height: 36px !important;
  }

  & .select__value-container {
    padding-bottom: 0 !important;
  }

  & .select__value-container > div {
    font-size: 16px;
    margin: 0 !important;
  }

  & .select__input input {
    width: 100px !important;
  }

  & .select__input {
    top: -4px !important;
  }

  & .select__menu,
  & .select__menu-list {
    width: 225px !important;
  }

  & .select__control {
    min-height: unset !important;
  }

  @media (max-width: ${device.mobileM}) {
    width: 120px;
  }

  @media (max-width: 335px) {
    width: 105px;
  }
`;

export const ErrorMessage = styled(BaseErrorMessage)`
  padding-top: 1px;
  bottom: initial;
`;

export const LabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

export const TooltipStyled = styled(Tooltip)`
  position: relative;
  top: -2px;
`;
